import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack} from 'views/components';

import CareViewItem from './view/CareViewItem';

// The read-only copy of the client Careview tab. It lists the questions in rank order and has no
// new, delete, reset or reorder.
const CareviewSettings = (props) => {
  const clientCareviewSettings = props.clientCareviewSettings;

  const careviewList = React.useMemo(() => {
    const careviewQuestions = clientCareviewSettings?.careviewQuestions;

    if (!careviewQuestions) {
      return [];
    }

    return Object.values(careviewQuestions).sort((a, b) => a.rankorder - b.rankorder);
  }, [clientCareviewSettings]);

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      {/* The legacy list sat in a drag container. This keeps its minimum height for an empty list. */}
      <Box
        sx={{
          minHeight: '30px',
        }}
      >
        {
          careviewList.map((e, index) => (
            <CareViewItem
              key={e.questionRn}
              index={index + 1}
              careviewItem={e}
            />
          ))
        }
      </Box>
    </Stack>
  );
};

CareviewSettings.propTypes = {
  clientCareviewSettings: PropTypes.object.isRequired,
};
export default React.memo(CareviewSettings);
